module.exports = __webpack_public_path__ + "assets/img/mecha-text-bg-7f1c8d99.png";